import fetchHandler from "../../utils/fetchHandler";
import { HOME } from "../types/actions";

export const getHomeData = () => {
	const fetchOptions = {
		url: `/api/exercises/my_home`,
		method: "GET",
		actionType: HOME.GET_HOME_DATA
	};
	return fetchHandler(fetchOptions);
};

export const getWeightHistory = () => {
	const fetchOptions = {
		url: `/api/statistics`,
		method: "GET",
		actionType: HOME.GET_WEIGHT_HISTORY
	};
	return fetchHandler(fetchOptions);
};

export const getAds = (errorHandler) => {
	const fetchOptions = {
		url: `/api/ads/random`,
		method: "GET",
		actionType: HOME.GET_ADS
	};
	return fetchHandler(fetchOptions, null, errorHandler);
};

export const getMotivationalVideos = () => {
	const fetchOptions = {
		url: `/api/motivational/random`,
		method: "GET",
		actionType: HOME.GET_MOTIVATIONAL_VIDEOS
	};
	return fetchHandler(fetchOptions);
};
